import React from 'react';
import AsyncInput from '../AsyncInput';
import InputSearch from '../InputSearch';
import FilterField from './FilterField';
import CustomDatePicker from '../CustomDatePicker';
import Selector from '../Selector';

const SearchBar = ({ inputs }) => {
  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-x-4 gap-y-2 mt-4 flex-wrap">
      {inputs.map((input, index) => {
        const key = input.key ?? index;

        if (input.type === 'search') {
          return <AsyncInput key={key} {...input} />;
        }
        if (input.type === 'simpleSearch') {
          return <InputSearch key={key} {...input} showReset={true} />;
        }
        if (input.type === 'filter') {
          return <FilterField key={key} {...input} />;
        }
        if (input.type === 'selector') {
          return <Selector key={key} {...input} />;
        }
        if (input.type === 'date') {
          return <CustomDatePicker key={key} {...input} />;
        }
      })}
    </div>
  );
};
export default SearchBar;
